import { HANDLE_SUBSCRIPTION, SET_SHARE_SCREEN_BTN } from "./types";

export const handleSubscription = (payload)  => ({
    type: HANDLE_SUBSCRIPTION,
    payload,
})

export const setShareScreenBtn = (payload) => ({
    type: SET_SHARE_SCREEN_BTN,
    payload
})